module.exports = __webpack_public_path__ + "static/img/ldt5.8689b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt5.png
// module id = awKh
// module chunks = 0